import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import {
  getTemperature,
  getTemperatureUnit,
} from '../../../../../../helper/temperature';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';

@Component({
  selector: 'app-p00030-card-tair-statut',
  templateUrl: './p00030-card-tair-statut.component.html',
  styleUrls: ['./p00030-card-tair-statut.component.scss'],
  standalone: true,
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00030CardTAirStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  getTemperatureContent() {
    return getTemperature(
      this.actionStack!.getValue('taSMesureTemperature', null) / 10,
    );
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.TAIR,
      FunctionOnglet.STATUS,
      this.translateService.instant('P00030.dashboard.card.title'),
    );
  }
}
